import { GridColDef } from "@mui/x-data-grid";

export const invoiceCategoryColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
